<script lang="ts" setup>
import { getStaticImages } from '@/utils';
import { useRouter } from 'vue-router';

const props = defineProps<{ pageData: string }>();
const router = useRouter();

const goBack = () => {
    if (window.history.length > 1) {
        window.history.back();
    } else {
        router.push({ name: 'grid' });
    }
};
</script>

<template>
    <div class="textpages__content textpages__404">
        <section class="textpages__content-col2">
            <div class="card">
                <h3>{{ $t('textpages.404.cardTitle') }}</h3>
                <p v-html="$t('textpages.404.cardDesc')"></p>
            </div>
            <div class="buttons">
                <button class="btn btn-black btn-small" @click="goBack">
                    {{ $t('textpages.404.previous') }}
                </button>
                <router-link class="btn btn-orange btn-small" :to="{name:'grid'}">{{ $t('textpages.404.home') }}</router-link>
            </div>
        </section>
        <section class="textpages__content-col2">
            <img alt="404" :src="getStaticImages('404','png')" />
        </section>
    </div> 
</template>